import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Box } from '@mui/material';
import LeadDialog from './LeadDialog';
import './BiztantuConfirmDialog.css';

/**
 * BiztantuConfirmDialog
 * Reusable confirmation & warning dialog wrapping LeadDialog with standard Biztantu styling.
 */
const BiztantuConfirmDialog = ({
  open = false,
  onClose,
  onConfirm,
  title = 'Confirmation',
  message,
  children,
  confirmBtnLabel = 'Yes',
  cancelBtnLabel = 'Cancel',
  isWarning = false,
  isAlertOnly = false,
  size = 'sm',
  loading = false,
  btnSize = 'medium'
}) => {
  if (!open) return null;

  return (
    <LeadDialog
      open={open}
      handleClose={onClose}
      handleSave={isAlertOnly ? onClose : onConfirm}
      title={
        <Box className="biztantu-confirm-header-box">
          <span>{title}</span>
        </Box>
      }
      size={size}
      btnlabel={confirmBtnLabel}
      alternateBtnLabel={isAlertOnly ? '' : cancelBtnLabel}
      btnSize={btnSize}
    >
      {message && (
        <Typography gutterBottom className="biztantu-confirm-message">
          {message}
        </Typography>
      )}
      {children}
    </LeadDialog>
  );
};



export default React.memo(BiztantuConfirmDialog);
